import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef,} from '@angular/material/dialog';
import {EditSettingsModel, GridComponent, SaveEventArgs, ToolbarItems} from '@syncfusion/ej2-angular-grids';
import {ObjektModels} from 'src/app/models/objekt-models';
import {L10n, setCulture, setCurrencyCode} from '@syncfusion/ej2-base';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {SwissInternService} from 'src/app/services/swiss-intern.service';
import {v4 as uuidv4} from 'uuid';
import {formatCurrency} from '@angular/common';
import {BenutzerModels} from 'src/app/models/benutzer-models';
import {SwissInternModels} from 'src/app/models/swissintern-models';
import jsPDF from 'jspdf';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {DokumentDataService} from 'src/app/services/dokument-data.service';
import {DokumentModels} from 'src/app/models/dokument-models';
import {SwissAppConfigModels} from 'src/app/models/swissappconfig-models';
import {UserAuthenticationService} from '../../../services/user-authentication.service';
import {PDFViewerDialogComponent} from '../../../pdfviewer/pdfviewerDialog.component';

setCulture('de-CH');
setCurrencyCode('CHF');

L10n.load({
    'de-CH': {
        'grid': {
            'Add': 'Hinzufügen',
            'Edit': 'Bearbeiten',
            'Delete': 'Löschen',
            'Update': 'Speichern',
            'Cancel': 'Abbrechen'
        }
    }
});

@Component({
    selector: 'app-objekt-rapport',
    templateUrl: './objekt-rapport.component.html',
    styleUrls: ['./objekt-rapport.component.scss']
})
export class ObjektRapportComponent implements OnInit, AfterViewInit {
    @ViewChild('grid')
    public grid!: GridComponent;
    public editSettings?: EditSettingsModel;
    public toolbar: ToolbarItems[] = ['Add', 'Edit', 'Delete', 'Update', 'Cancel'];
    public positionen: ObjektModels.ObjektRapportPosition[] = [];
    public positionenFormatted: ObjektModels.ObjektRapportPosition[] = [];
    public mwstSatz: string;
    /* PDF-Erzeugung */
    @ViewChild('sigCanvas') signatureCanvas?: ElementRef<HTMLCanvasElement>;
    public contextSignatureCanvas?: CanvasRenderingContext2D | undefined | null;
    public rapportGenerationInProgress: boolean = false;
    public isSigned: boolean = false;
    public rapportIsCreated: boolean = false;
    private defaultPosition: ObjektModels.ObjektRapportPosition;
    private currentPosID?: string;
    /* Summierung / Totalisierung */
    private totalPreisExkl: number = 0.0;
    private totalMwSt: number = 0.0;
    private totalPreisInkl: number = 0.0;
    private waehrung: string = 'CHF';
    private mwstSatzValue: number;
    private currAnwender?: BenutzerModels.Anwender;
    private paint: boolean = false;
    private clickX: number[] = [];
    private clickY: number[] = [];
    private clickDrag: boolean[] = [];
    private si_PDFRapport: SwissInternModels.SI_PDFRapport = {
        invoice: undefined,
        positions: {},
        type: 'SwissInternerRapport'
    };
    private rapportFile?: SwissInternModels.BaseFile;

    /* ENDE PDF-Erzeugung */


    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<ObjektRapportComponent>,
        private datumFormatPipe: DatumFormatPipe,
        private svcObjekte: ObjektDataService,
        private svcDokuData: DokumentDataService,
        private svcSwissIntern: SwissInternService,
        private svcSwissSettings: SwissSettingsService,
        private userAuthService: UserAuthenticationService,
        public svcMessageBox: MessageBoxService,
        @Inject(MAT_DIALOG_DATA) public diaData: ObjektModels.ObjektRapportDialogInput,
    ) {
        this.currAnwender = this.userAuthService.getCurrentAuthenticatedUser();

        this.defaultPosition = {
            objectID: diaData.objectID,
            id_ObjektRapportPosition: uuidv4(),
            datum: datumFormatPipe.getTodaySwissFormat(),
            mitarbeiter: diaData.mitarbeiter,
            arbeitsbezeichnung: 'Fahrzeit',
            aufwandInStunden: 1.25,
            preis: 180.00,
            preisStr: '180.00',
            total: 225.00,
            totalStr: '225.00',
            rabatt: undefined
        };

        /* MwSt-Satz wird aus der Service-App des Mitarbeiters entnommen */
        this.mwstSatzValue = 7.7;
        if (this.currAnwender!.sA_PercentageVAT!) {
            this.mwstSatzValue = this.currAnwender!.sA_PercentageVAT!;
        }

        this.mwstSatz = String((Math.round(this.mwstSatzValue * 100) / 100).toFixed(2)).replace(',', '.');

        this.editSettings = {
            allowEditing: true,
            allowAdding: true,
            allowDeleting: true
        };
    }

    ngOnInit(): void {
        // Prüfen, ob das Objekt schon gespeicherte Daten in der Indexed-DB hat
        this.svcSwissIntern.getPositionsFromIndexedDB(this.diaData.objectID).then(value => {
            if (value && value.length > 0) {
                this.positionen = value;
            } else {
                this.positionen.push(this.defaultPosition);
            }
            this.refreshGrid();
        });
    }

    /* START CANVAS */
    ngAfterViewInit(): void {
        // Canvas
        if (this.signatureCanvas) {
            this.contextSignatureCanvas =
                this.signatureCanvas!.nativeElement.getContext('2d');
            this.contextSignatureCanvas!.fillStyle = 'black';
            this.contextSignatureCanvas!.clearRect(
                0,
                0,
                this.signatureCanvas!.nativeElement.width,
                this.signatureCanvas!.nativeElement.height
            );

            /* Canvas Events */
            this.contextSignatureCanvas!.canvas.addEventListener(
                'mousedown',
                this.pressEventHandler
            );
            this.contextSignatureCanvas!.canvas.addEventListener(
                'mousemove',
                this.dragEventHandler
            );
            this.contextSignatureCanvas!.canvas.addEventListener(
                'mouseup',
                this.releaseEventHandler
            );
            this.contextSignatureCanvas!.canvas.addEventListener(
                'mouseout',
                this.cancelEventHandler
            );

            this.contextSignatureCanvas!.canvas.addEventListener(
                'touchstart',
                this.pressEventHandler
            );
            this.contextSignatureCanvas!.canvas.addEventListener(
                'touchmove',
                this.dragEventHandler
            );
            this.contextSignatureCanvas!.canvas.addEventListener(
                'touchend',
                this.releaseEventHandler
            );
            this.contextSignatureCanvas!.canvas.addEventListener(
                'touchcancel',
                this.cancelEventHandler
            );

            this.contextSignatureCanvas!.lineCap = 'round';
            this.contextSignatureCanvas!.lineJoin = 'round';
            this.contextSignatureCanvas!.strokeStyle = 'black';
            this.contextSignatureCanvas!.lineWidth = 2;
            this.redraw();
        }
    }

    // Total pro Zeile berechnen
    public totalPosition = (field: string, data: { id_ObjektRapportPosition: string, aufwandInStunden: number, preis: number, rabatt: number, total: number }, column: Object): number => {
        let total: number;

        if (data.rabatt) {
            total = (data.aufwandInStunden * data.preis) * (100 - data.rabatt) / 100;
        } else {
            total = data.aufwandInStunden * data.preis;
        }
        data.total = total;
        let idx = this.positionen.findIndex(x => x.id_ObjektRapportPosition === data.id_ObjektRapportPosition);
        if (idx >= 0) {
            this.positionen[idx].total = total;
        }
        return total;
    };

    public valueAccess = (field: string, data1: any, column: object) => {
        if (data1[field]) {
            return data1[field] + '%';
        } else {
            return '';
        }
    };

    getDefaultID() {
        // Der PK der Zeile darf nicht wechseln
        if (!this.currentPosID) {
            this.currentPosID = uuidv4();
        }
        return this.currentPosID;
    }

    getDefaultDatum() {
        return this.datumFormatPipe.getTodaySwissFormat();
    }

    getDefaultMitarbeiter() {
        return this.diaData.mitarbeiter;
    }

    getDefaultAnsatz() {
        return 180.00;
    }

    // Funktionen für die Summierung von Preisen / MwSt
    public customAggregateTotalExkl = (sdata: String) =>
        formatCurrency(this.totalPreisExkl, 'de-CH', this.waehrung, '1.2-2').replace(
            ',',
            '.'
        );

    public customAggregateMwSt = (sdata: String) =>
        formatCurrency(this.totalMwSt, 'de-CH', this.waehrung, '1.2-2').replace(',', '.');

    public customAggregateTotalInkl = (sdata: String) =>
        formatCurrency(this.totalPreisInkl, 'de-CH', this.waehrung, '1.2-2').replace(
            ',',
            '.'
        );

    onActionComplete(args: SaveEventArgs) {
        if (args.requestType === 'save' || args.requestType === 'delete') {
            this.refreshGrid();
        }
    }

    async refreshGrid() {
        this.totalPreisExkl = 0.0;
        this.totalMwSt = 0.0;
        this.totalPreisInkl = 0.0;

        if (this.positionen && this.positionen.length > 0) {
            this.positionen.forEach(x => {
                console.log('Refresh Grid - In Calc', x.total, this.totalPreisExkl);
                this.totalPreisExkl += Number(x.total);
            });
            this.grid.refresh();
        }

        this.totalMwSt = (this.mwstSatzValue * this.totalPreisExkl) / 100.0;
        // Hier wird die MwSt auf 0.05 Rappen gerundet
        this.totalMwSt = parseFloat(
            (Math.ceil(this.totalMwSt * 20) / 20).toFixed(2)
        );
        this.totalPreisInkl = this.totalPreisExkl + this.totalMwSt;
    }

    async save() {
        await this.svcSwissIntern.SaveRapportPositions(this.diaData.objectID, this.positionen);
        this.dialogRef.close();
    }

    async createRapport() {
        if (this.rapportGenerationInProgress) {
            return;
        }
        this.rapportGenerationInProgress = true;

        if (this.isSigned) {
            if (!this.si_PDFRapport.invoice)

                /* Array kopieren und formattieren*/{
                this.positionenFormatted = [];
            }
            this.positionen.forEach(val => this.positionenFormatted.push(Object.assign({}, val)));
            this.positionenFormatted.forEach(val => {
                    val.preisStr = formatCurrency(val.preis, 'de-CH', this.waehrung, '1.2-2').replace(',', '.');
                    val.totalStr = formatCurrency(val.total, 'de-CH', this.waehrung, '1.2-2').replace(',', '.');
                }
            );

            await this.initRapport();
            this.si_PDFRapport.invoice!.mandantAdr = this.userAuthService.getCurrentMandant();

            await this.svcObjekte.loadRapportLogo().then(
                (res) => {
                    this.si_PDFRapport.invoice!.logo = res;
                },
                (error) => {
                    console.error(
                        'Das Rapport-Logo konnte nicht geladen werden!!!',
                        error
                    );
                }
            );
            console.log('Create Report fertig');

            if (this.si_PDFRapport.invoice) {
                try {
                    this.svcObjekte.makeRapport(this.si_PDFRapport, this.diaData.objectID!, this.totalPreisExkl, this.totalMwSt, this.totalPreisInkl, this.signatureCanvas!, this.isSigned).then((res) => {
                        this.totalPreisExkl = 0.0;
                        this.totalMwSt = 0.0;
                        this.totalPreisInkl = 0.0;
                        this.rapportIsCreated = true;
                        let alleObjektRapporte = this.svcObjekte.getRapporteByObjectID(this.diaData.objectID);
                        this.rapportFile = alleObjektRapporte[alleObjektRapporte.length - 1];
                    });
                } catch (ex) {
                    console.error('Fehler im Erstellen des Rapports: ', ex);
                }
            }
        } else {
            this.rapportGenerationInProgress = false;
        }
    }

    clearSignature() {
        this.contextSignatureCanvas!.clearRect(
            0,
            0,
            this.signatureCanvas!.nativeElement.width,
            this.signatureCanvas!.nativeElement.height
        );
        this.clickX = [];
        this.clickY = [];
        this.clickDrag = [];
        this.isSigned = false;
    }

    async initRapport() {
        let reports = await this.svcSwissSettings.getServiceAppReports();
        let objektReport: SwissAppConfigModels.SwissAppReport | undefined;
        if (reports) {
            objektReport = reports.filter(x => x.iD_SwissAppReportType === 2)[0];
            if (objektReport) {
                if (!this.positionen) {
                    this.positionen = [];
                }
                this.si_PDFRapport.invoice = {
                    template: JSON.parse(objektReport!.pdfFormularConfigJSONData),
                    doc: new jsPDF('p', 'pt', 'a4'),
                    pdf: null,
                    completed: false,
                    mandantAdr: null,
                    columns: [],
                    rows: this.positionenFormatted,
                    pointer: 0,
                    output: null,
                    name: 'Rapport_Aussendienst.pdf',
                    address: null,
                    MiscTablePos: null,
                    data: [],
                    reset: false,
                    relativepageadded: false,
                    logo: '',
                    footerLogoPath: '',
                    logoFooter: '',
                    printPositionsTable: objektReport.printPositionsTable
                };
            } else {
                this.svcMessageBox.showError(
                    'Es konnte kein Report für die Objekte ermittelt werden. ',
                    '!! Fehler !!'
                );
            }
        }
    }

    showRapport() {
        // Der Rapport soll im PDF-Viewer angezeigt werden
        this.svcDokuData.setPDFDokument(
            this.diaData.objectID,
            this.rapportFile!.documentID,
            this.rapportFile!.fileName,
            this.rapportFile!.description,
            DokumentModels.DokumentTyp.ObjektRapport,
            DokumentModels.DokumentSource.ObjektRapport,
            new Date(),
            this.diaData.pdfList
        );
        this.openPDFViewerDialog();
        this.dialogRef.close();
    }

    private redraw() {
        let clickX = this.clickX;
        let clickDrag = this.clickDrag;
        let clickY = this.clickY;
        for (let i = 0; i < clickX.length; ++i) {
            this.contextSignatureCanvas!.beginPath();
            if (clickDrag[i] && i) {
                this.contextSignatureCanvas!.moveTo(clickX[i - 1], clickY[i - 1]);
            } else {
                this.contextSignatureCanvas!.moveTo(clickX[i] - 1, clickY[i]);
            }
            this.contextSignatureCanvas!.lineTo(clickX[i], clickY[i]);
            this.contextSignatureCanvas!.stroke();
        }
        this.contextSignatureCanvas!.closePath();
    }

    private addClick(x: number, y: number, dragging: boolean) {
        this.clickX.push(x);
        this.clickY.push(y);
        this.clickDrag.push(dragging);
    }

    private pressEventHandler = (e: MouseEvent | TouchEvent) => {
        var rect = this.signatureCanvas!.nativeElement.getBoundingClientRect();
        let mouseX = (e as TouchEvent).changedTouches
            ? (e as TouchEvent).changedTouches[0].pageX - rect.left
            : (e as MouseEvent).offsetX;
        let mouseY = (e as TouchEvent).changedTouches
            ? (e as TouchEvent).changedTouches[0].pageY - rect.top
            : (e as MouseEvent).offsetY;
        this.isSigned = true;
        this.paint = true;
        this.addClick(mouseX, mouseY, false);
        this.redraw();
    };

    private dragEventHandler = (e: MouseEvent | TouchEvent) => {
        var rect = this.signatureCanvas!.nativeElement.getBoundingClientRect();

        let mouseX = (e as TouchEvent).changedTouches
            ? (e as TouchEvent).changedTouches[0].pageX - rect.left
            : (e as MouseEvent).offsetX;
        let mouseY = (e as TouchEvent).changedTouches
            ? (e as TouchEvent).changedTouches[0].pageY - rect.top
            : (e as MouseEvent).offsetY;

        if (this.paint) {
            this.addClick(mouseX, mouseY, true);
            this.redraw();
        }
        e.preventDefault();
    };

    private releaseEventHandler = () => {
        this.paint = false;
        this.redraw();
    };

    private cancelEventHandler = () => {
        this.paint = false;
    };

    private openPDFViewerDialog() {
        this.dialog.open(PDFViewerDialogComponent, {
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: '100%',
            width: '100%',
            data: {isDialogMode: true}
        });
    }
}
